import React, { useRef } from 'react';
import styled from 'styled-components';
import Navbar, { SCROLL_BEHAVIOR } from './Navbar';
import Footer from './Footer';
import { CTGCBanner } from '../common/CTGCBanner';
import WorkPasswordGate from '../work/WorkPasswordGate';

type Props = React.HTMLAttributes<HTMLDivElement>;

export const WorkLayout: React.FunctionComponent<Props> = ({ children }) => 
{
    const ref = useRef<HTMLDivElement>(null);
    return (
        <WorkPasswordGate>
            <>
                <Navbar scrollBehavior={{ mobile: SCROLL_BEHAVIOR.OPAQUE_AFTER_SCROLL }} />
                <Container id="container" ref={ref}>
                    <NavSpacer />
                    {children}
                    <Footer />
                    <CTGCBanner />
                </Container>
            </>
        </WorkPasswordGate>
    );
};

const Container = styled.div`
    position: relative;
    z-index: 0;
    width : 100%;
     overflow-x: hidden;
`;

const NavSpacer = styled.div`
    position: sticky;
    top: 0;
    height: 77px;
    pointer-events: none;
    background: transparent;
    z-index: 0;
`;